import { render } from "./make-header-using-bootstrap.vue?vue&type=template&id=266f8d13"
import script from "./make-header-using-bootstrap.vue?vue&type=script&lang=js"
export * from "./make-header-using-bootstrap.vue?vue&type=script&lang=js"

import "./make-header-using-bootstrap.vue?vue&type=style&index=0&id=266f8d13&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__